import React, { useEffect, useState } from "react";
import { Spin, Empty, message, Tag } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./MyEstimates.css";

const Stat = ({ label, value }) => (
  <div>
    <span className="estimate-stat__label">{label}</span>
    <span className="estimate-stat__value">{value}</span>
  </div>
);

const MyEstimates = () => {
  const [estimates, setEstimates] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    checkUserActiveStatus();
    fetchEstimates();
    // eslint-disable-next-line
  }, []);

  const checkUserActiveStatus = async () => {
    const tokenString = localStorage.getItem("token");

    try {
      let config = {
        method: "get",
        url:
          global.config.APIURL.BaseURL + "api/UserAccount/GetUserAccountDetail",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tokenString,
        },
      };

      axios
        .request(config)
        .then((response) => {
          if (
            response.data.IsActive === false ||
            response.data.IsDeleted === true
          ) {
            alert("Your session has expired. Please log in again.");

            localStorage.removeItem("token");
            localStorage.removeItem("userName");
            window.location.reload();
          }
        })
        .catch((error) => {});
    } catch (error) {}
  };

  const fetchEstimates = async () => {
    setLoading(true);
    try {
      const tokenString = localStorage.getItem("token");
      const response = await axios.get(
        global.config.APIURL.BaseURL + "api/Estimate/GetEstimateList",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + tokenString,
          },
        }
      );
      setEstimates(response.data || []);
    } catch (error) {
      message.error("Failed to fetch estimates.");
      setEstimates([]);
    }
    setLoading(false);
  };

  // Helper for Indian number format with 2 decimals
  const formatINR = (value) =>
    value !== undefined && value !== null
      ? value.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "0.00";

  // Helper for date format "dd-MM-yyyy"
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const openEstimate = (estimateId) => navigate(`/estimatedetail/${estimateId}`);

  return (
    <div className="estimates-page">
      <div className="estimates-header">
        <h1>My Estimates</h1>
        {!loading && estimates.length > 0 && (
          <p>
            {estimates.length} estimate{estimates.length !== 1 ? "s" : ""}{" "}
            received
          </p>
        )}
      </div>

      {loading ? (
        <div style={{ textAlign: "center", padding: 72 }}>
          <Spin size="large" />
        </div>
      ) : estimates.length === 0 ? (
        <Empty
          description="No estimates found"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          style={{ padding: "64px 0" }}
        />
      ) : (
        <div className="estimates-list">
          {estimates.map((record) => (
            <div
              className="estimate-card"
              key={record.EstimateID}
              role="button"
              tabIndex={0}
              onClick={() => openEstimate(record.EstimateID)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  openEstimate(record.EstimateID);
                }
              }}
            >
              <div className="estimate-card__top">
                <div style={{ minWidth: 0 }}>
                  <div className="estimate-card__id">
                    <span>
                      Estimate {record.FinalEstimateNo || `#${record.EstimateID}`}
                    </span>
                    {record.Status === "EditedByCustomer" && (
                      <Tag color="blue" style={{ margin: 0 }}>
                        Edited
                      </Tag>
                    )}
                  </div>
                  <div className="estimate-card__date">
                    <CalendarOutlined />
                    {formatDate(record.EstimateDate)}
                  </div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div className="estimate-card__total-label">Grand Total</div>
                  <div className="estimate-card__total">
                    ₹{formatINR(record.GrandTotal)}
                  </div>
                </div>
              </div>

              <div className="estimate-card__rule" />

              {/* FinalSubTotal (not SubTotal) so the card reconciles with Grand Total whether or
                  not a discount was applied - the discount itself is never shown here. */}
              <div className="estimate-card__stats">
                <Stat label="Boxes" value={formatINR(record.TotalBox)} />
                <Stat
                  label="Quantity"
                  value={formatINR(record.TotalQuantity)}
                />
                <Stat
                  label="Sub Total"
                  value={`₹${formatINR(record.FinalSubTotal)}`}
                />
                <Stat
                  label="GST"
                  value={`₹${formatINR(
                    (record.TotalCgst || 0) + (record.TotalSgst || 0)
                  )}`}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyEstimates;
